const initApplicationState = (initialState, store) => {
};

export default initApplicationState;
